module.exports = __webpack_public_path__ + "img/bulletin_healthcare_plugin.aed23fe9.png";